import base from './base';
import dialog from './dialog';
import table from './table';

export {
    dialog,
    table,
    base
}


// WEBPACK FOOTER //
// ./src/vuex-extend/index.js